import { Controller } from '@hotwired/stimulus';
import { modalController } from '@ionic/core';

// Controls ionic modal
export default class extends Controller {
  close() {
    this.element.isOpen = false;
    this.element.dismiss(null, 'cancel');
  }
}
